/* ATTACK SHARK About page interactions. Loaded with `defer`. */
(function () {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initTabs() {
    const root = document.querySelector('.as-about-module-3');
    if (!root || root.dataset.initialized) return;
    const tabs = Array.from(root.querySelectorAll('.as-about-tab'));
    const panels = Array.from(root.querySelectorAll('.as-about-panel'));
    if (!tabs.length || tabs.length !== panels.length) return;
    root.dataset.initialized = 'true';

    function activate(index, focus) {
      tabs.forEach(function (tab, currentIndex) {
        const active = currentIndex === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      panels.forEach(function (panel, currentIndex) {
        const active = currentIndex === index;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { activate(index, false); });
      tab.addEventListener('keydown', function (event) {
        const steps = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1, Home: 'start', End: 'end' };
        if (!(event.key in steps)) return;
        event.preventDefault();
        const step = steps[event.key];
        const next = step === 'start' ? 0 : step === 'end' ? tabs.length - 1 : (index + step + tabs.length) % tabs.length;
        activate(next, true);
      });
    });
    activate(Math.max(0, tabs.findIndex(function (tab) { return tab.getAttribute('aria-selected') === 'true'; })), false);
  }
// <!-- ================= MODULE 04 ================= -->
function initTimeline() {
  const root = document.querySelector('.as-about-module-4');

  if (!root || root.dataset.initialized === 'true') {
    return;
  }

  const track = root.querySelector('#as-about-timeline-track');
  const viewport = root.querySelector('.as-about-timeline-window');
  const events = Array.from(
    root.querySelectorAll('.as-about-event')
  );
  const previous = root.querySelector('#as-about-prev');
  const next = root.querySelector('#as-about-next');

  if (
    !track ||
    !viewport ||
    !events.length ||
    !previous ||
    !next
  ) {
    return;
  }

  root.dataset.initialized = 'true';

  const reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const mobile = window.matchMedia(
    '(max-width: 760px)'
  );

  let currentPage = 0;
  let resizeFrame = 0;
  let pointerStartX = 0;
  let pointerStartY = 0;
  let pointerActive = false;

  function getVisibleCount() {
    return mobile.matches ? 2 : 4;
  }

  function getGap() {
    const styles = window.getComputedStyle(track);

    return (
      Number.parseFloat(
        styles.columnGap || styles.gap
      ) || 0
    );
  }

  function getCardWidth() {
    if (!events[0]) {
      return 0;
    }

    return events[0].getBoundingClientRect().width;
  }

  function getPageCount() {
    const visibleCount = getVisibleCount();

    return Math.max(
      1,
      Math.ceil(
        events.length /
          visibleCount
      )
    );
  }

  function getMaxPage() {
    return Math.max(
      0,
      getPageCount() - 1
    );
  }

  /*
   * 计算当前页真正应该从哪个 event 开始。
   *
   * 10 个节点 / PC 5 个：
   *
   * page 0 -> index 0
   * page 1 -> index 5
   *
   * 如果以后不是整页数量，
   * 最后一页自动吸附到最后几个节点，
   * 不会出现右侧空白或卡片被裁掉。
   */
  function getPageStartIndex(page) {
    const visibleCount = getVisibleCount();

    const maxStartIndex = Math.max(
      0,
      events.length - visibleCount
    );

    return Math.min(
      page * visibleCount,
      maxStartIndex
    );
  }

  function updateAccessibility() {
    const visibleCount = getVisibleCount();
    const startIndex =
      getPageStartIndex(currentPage);

    const endIndex =
      startIndex + visibleCount - 1;

    events.forEach(function(event, index) {
      const visible =
        index >= startIndex &&
        index <= endIndex;

      event.setAttribute(
        'aria-hidden',
        visible ? 'false' : 'true'
      );

      if (visible) {
        event.setAttribute(
          'tabindex',
          '0'
        );
      } else {
        event.setAttribute(
          'tabindex',
          '-1'
        );
      }
    });

    const page = currentPage + 1;
    const total = getPageCount();

    previous.setAttribute(
      'aria-label',
      'Previous timeline page'
    );

    next.setAttribute(
      'aria-label',
      'Next timeline page'
    );

    root.setAttribute(
      'data-timeline-page',
      page + '/' + total
    );
  }

  function updateTimeline(animate = true) {
    const visibleCount =
      getVisibleCount();

    const cardWidth =
      getCardWidth();

    const gap =
      getGap();

    if (
      !cardWidth ||
      !viewport.clientWidth
    ) {
      return;
    }

    const maxPage =
      getMaxPage();

    currentPage =
      Math.max(
        0,
        Math.min(
          currentPage,
          maxPage
        )
      );

    const startIndex =
      getPageStartIndex(
        currentPage
      );

    const step =
      cardWidth + gap;

    const offset =
      startIndex * step;

    const animated =
      animate &&
      !reduceMotion.matches;

    track.style.transitionDuration =
      animated ? '' : '0ms';

    track.style.transform =
      'translate3d(-' +
      offset +
      'px,0,0)';

    previous.disabled =
      currentPage === 0;

    next.disabled =
      currentPage === maxPage;

    updateAccessibility();

    if (!animated) {
      window.requestAnimationFrame(
        function() {
          track.style.transitionDuration =
            '';
        }
      );
    }
  }

  function goToPage(
    page,
    animate = true,
    focus = false
  ) {
    const maxPage =
      getMaxPage();

    currentPage =
      Math.max(
        0,
        Math.min(
          page,
          maxPage
        )
      );

    updateTimeline(animate);

    if (focus) {
      const targetIndex =
        getPageStartIndex(
          currentPage
        );

      const target =
        events[targetIndex];

      if (target) {
        window.requestAnimationFrame(
          function() {
            target.focus({
              preventScroll:true
            });
          }
        );
      }
    }
  }

  function nextPage(
    animate = true,
    focus = false
  ) {
    if (
      currentPage >=
      getMaxPage()
    ) {
      return;
    }

    goToPage(
      currentPage + 1,
      animate,
      focus
    );
  }

  function previousPage(
    animate = true,
    focus = false
  ) {
    if (
      currentPage <= 0
    ) {
      return;
    }

    goToPage(
      currentPage - 1,
      animate,
      focus
    );
  }

  /* ========================================
     Buttons
     ======================================== */

  previous.addEventListener(
    'click',
    function() {
      previousPage(true, false);
    }
  );

  next.addEventListener(
    'click',
    function() {
      nextPage(true, false);
    }
  );

  /* ========================================
     Keyboard
     ======================================== */

  events.forEach(function(event) {
    event.addEventListener(
      'keydown',
      function(e) {
        if (
          ![
            'ArrowLeft',
            'ArrowRight',
            'Home',
            'End'
          ].includes(e.key)
        ) {
          return;
        }

        e.preventDefault();

        if (e.key === 'ArrowLeft') {
          previousPage(true, true);
          return;
        }

        if (e.key === 'ArrowRight') {
          nextPage(true, true);
          return;
        }

        if (e.key === 'Home') {
          goToPage(
            0,
            true,
            true
          );
          return;
        }

        if (e.key === 'End') {
          goToPage(
            getMaxPage(),
            true,
            true
          );
        }
      }
    );
  });

  /* ========================================
     Touch / Pointer Swipe
     ======================================== */

  viewport.addEventListener(
    'pointerdown',
    function(e) {
      if (
        e.pointerType === 'mouse' ||
        e.button !== 0
      ) {
        return;
      }

      pointerActive = true;
      pointerStartX = e.clientX;
      pointerStartY = e.clientY;
    },
    {
      passive:true
    }
  );

  viewport.addEventListener(
    'pointerup',
    function(e) {
      if (!pointerActive) {
        return;
      }

      pointerActive = false;

      const deltaX =
        e.clientX - pointerStartX;

      const deltaY =
        e.clientY - pointerStartY;

      const horizontal =
        Math.abs(deltaX) >
        Math.abs(deltaY);

      const threshold =
        Math.max(
          40,
          viewport.clientWidth * .12
        );

      if (
        !horizontal ||
        Math.abs(deltaX) < threshold
      ) {
        return;
      }

      if (deltaX < 0) {
        nextPage(true, false);
      } else {
        previousPage(true, false);
      }
    },
    {
      passive:true
    }
  );

  viewport.addEventListener(
    'pointercancel',
    function() {
      pointerActive = false;
    },
    {
      passive:true
    }
  );

  /* ========================================
     Responsive
     ======================================== */

  function handleBreakpointChange() {
    currentPage = 0;

    updateTimeline(false);
  }

  if (
    typeof mobile.addEventListener ===
    'function'
  ) {
    mobile.addEventListener(
      'change',
      handleBreakpointChange
    );
  } else {
    mobile.addListener(
      handleBreakpointChange
    );
  }

  /* ========================================
     Resize
     ======================================== */

  function handleResize() {
    if (resizeFrame) {
      return;
    }

    resizeFrame =
      window.requestAnimationFrame(
        function() {
          resizeFrame = 0;
          updateTimeline(false);
        }
      );
  }

  if (
    'ResizeObserver' in window
  ) {
    const observer =
      new ResizeObserver(
        handleResize
      );

    observer.observe(
      viewport
    );
  } else {
    window.addEventListener(
      'resize',
      handleResize,
      {
        passive:true
      }
    );
  }

  /* ========================================
     Init
     ======================================== */

  updateTimeline(false);
}

if (
  document.readyState === 'loading'
) {
  document.addEventListener(
    'DOMContentLoaded',
    initTimeline,
    {
      once:true
    }
  );
} else {
  initTimeline();
}

  function initCounters() {
    const root = document.querySelector('.as-about-module-5');
    if (!root || root.dataset.initialized) return;
    const numbers = Array.from(root.querySelectorAll('.as-about-stat__number'));
    if (!numbers.length) return;
    root.dataset.initialized = 'true';
    const formatter = new Intl.NumberFormat('en-US');
    function render(element, value) { element.textContent = formatter.format(Math.round(value)) + (element.dataset.suffix || ''); }
    function animate(element) {
      const target = Number(element.dataset.value);
      if (!Number.isFinite(target) || reduceMotion.matches) return render(element, Number.isFinite(target) ? target : 0);
      const start = performance.now();
      const duration = 1500;
      element.classList.add('is-counting');
      function tick(now) {
        const progress = Math.min((now - start) / duration, 1);
        render(element, target * (1 - Math.pow(1 - progress, 3)));
        if (progress < 1) window.requestAnimationFrame(tick);
        else element.classList.remove('is-counting');
      }
      window.requestAnimationFrame(tick);
    }
    if (!('IntersectionObserver' in window)) return numbers.forEach(animate);
    const observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      numbers.forEach(function (number, index) { window.setTimeout(function () { animate(number); }, index * 100); });
      observer.disconnect();
    }, { threshold: 0.25 });
    observer.observe(root);
  }

  function initEsportsSlider() {
    const root = document.querySelector('.as-about-module-7');
    if (!root || root.dataset.initialized) return;
    const track = root.querySelector('.as-about-module-7__track');
    const slides = Array.from(root.querySelectorAll('.as-about-module-7__slide'));
    const dots = Array.from(root.querySelectorAll('.as-about-module-7__dot'));
    const previous = root.querySelector('.as-about-module-7__arrow--prev');
    const next = root.querySelector('.as-about-module-7__arrow--next');
    const copy = root.querySelector('[data-about-module-7-copy]');
    if (!track || !slides.length || dots.length !== slides.length || !previous || !next) return;
    root.dataset.initialized = 'true';
    const texts = [
      'ATTACK SHARK works with elite esports teams and professional players to put our products through real competitive environments and refine performance at the highest level.',
      'Our partnerships turn professional feedback into practical product improvements across mice, keyboards, and competitive setups.',
      'Precision, consistency, and low-latency control are validated through real competition, not only lab specifications.',
      'From team environments to individual professionals, ATTACK SHARK develops with players who demand reliable performance under pressure.',
      'We challenge the limits of gaming hardware together with the people who compete at the highest level.'
    ];
    let index = 0;
    function render(focus) {
      track.style.transform = 'translate3d(' + (-index * 100) + '%, 0, 0)';
      slides.forEach(function (slide, currentIndex) { slide.classList.toggle('is-active', currentIndex === index); });
      dots.forEach(function (dot, currentIndex) {
        const active = currentIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
        dot.tabIndex = active ? 0 : -1;
        if (active && focus) dot.focus();
      });
      if (copy) copy.textContent = texts[index];
    }
    function move(step, focus) { index = (index + step + slides.length) % slides.length; render(focus); }
    previous.addEventListener('click', function () { move(-1, false); });
    next.addEventListener('click', function () { move(1, false); });
    dots.forEach(function (dot, dotIndex) {
      dot.addEventListener('click', function () { index = dotIndex; render(false); });
      dot.addEventListener('keydown', function (event) {
        if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        index = event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + slides.length) % slides.length;
        render(true);
      });
    });
    render(false);
  }

  initTabs();
  initTimeline();
  initCounters();
  initEsportsSlider();
}());
// Exhibition
(function(){
  const root=document.querySelector('.as-about-module-11');
  if(!root||root.dataset.ready==='1')return;
  root.dataset.ready='1';
  const stack=root.querySelector('[data-stack]');
  const cards=[...root.querySelectorAll('[data-card]')];
  const bullets=[...root.querySelectorAll('[data-go]')];
  const prev=root.querySelector('[data-prev]');
  const next=root.querySelector('[data-next]');
  if(!stack||cards.length<2)return;
  let active=0,busy=false,raf=0,touchX=0,touchY=0;
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const render=()=>{
    cards.forEach((card,i)=>{
      const pos=(i-active+cards.length)%cards.length;
      card.dataset.pos=String(pos);
      card.tabIndex=pos===0?0:-1;
      card.setAttribute('aria-hidden',pos===0?'false':'true');
    });
    bullets.forEach((b,i)=>{
      const on=i===active;
      b.classList.toggle('is-active',on);
      b.setAttribute('aria-selected',on?'true':'false');
    });
  };
  const finish=()=>{busy=false;stack.classList.remove('is-busy')};
  const go=index=>{
    if(busy)return;
    const nextIndex=(index+cards.length)%cards.length;
    if(nextIndex===active)return;
    active=nextIndex;
    stack.classList.add('is-busy');
    if(raf)cancelAnimationFrame(raf);
    raf=requestAnimationFrame(()=>{
      render();
      raf=0;
      if(reduced.matches){finish();return}
      window.setTimeout(finish,680);
    });
  };
  bullets.forEach((b,i)=>b.addEventListener('click',()=>go(i),{passive:true}));
  prev.addEventListener('click',()=>go(active-1));
  next.addEventListener('click',()=>go(active+1));
  cards.forEach((card,i)=>card.addEventListener('click',()=>go(i)));
  root.addEventListener('keydown',e=>{
    if(e.key==='ArrowLeft'){e.preventDefault();go(active-1)}
    else if(e.key==='ArrowRight'){e.preventDefault();go(active+1)}
    else if(e.key==='Home'){e.preventDefault();go(0)}
    else if(e.key==='End'){e.preventDefault();go(cards.length-1)}
  });
  stack.addEventListener('touchstart',e=>{
    if(e.touches.length!==1)return;
    touchX=e.touches[0].clientX;
    touchY=e.touches[0].clientY;
  },{passive:true});
  stack.addEventListener('touchend',e=>{
    if(!touchX||e.changedTouches.length!==1)return;
    const dx=e.changedTouches[0].clientX-touchX;
    const dy=e.changedTouches[0].clientY-touchY;
    touchX=touchY=0;
    if(Math.abs(dx)<52||Math.abs(dx)
  <Math.abs(dy)*1.15)return;
    go(active+(dx<0?1:-1));
  },{passive:true});
  render();
})();
// 8
(function(){
  const root=document.querySelector('.as-about-module-8');
  if(!root||root.dataset.initialized)return;
  root.dataset.initialized='true';

  const thumbs=[...root.querySelectorAll('.as-about-module-8__thumb')];
  const media=[...root.querySelectorAll('.as-about-module-8__main-media')];
  const current=root.querySelector('.as-about-module-8__gallery-current');

  if(!thumbs.length||thumbs.length!==media.length)return;

  let index=0;
  let busy=false;

  function show(nextIndex){
    if(busy||nextIndex===index||nextIndex<0||nextIndex>=media.length)return;

    busy=true;

    thumbs[index].classList.remove('is-active');
    thumbs[index].setAttribute('aria-selected','false');

    media[index].classList.remove('is-active');

    const oldIndex=index;
    index=nextIndex;

    thumbs[index].classList.add('is-active');
    thumbs[index].setAttribute('aria-selected','true');
    media[index].classList.add('is-active');

    current.textContent=String(index+1).padStart(2,'0');

    window.setTimeout(function(){
      busy=false;
    },420);
  }

  thumbs.forEach(function(thumb,i){
    thumb.addEventListener('click',function(){
      show(i);
    });

    thumb.addEventListener('keydown',function(event){
      let nextIndex=null;

      if(event.key==='ArrowDown'||event.key==='ArrowRight'){
        nextIndex=(i+1)%thumbs.length;
      }

      if(event.key==='ArrowUp'||event.key==='ArrowLeft'){
        nextIndex=(i-1+thumbs.length)%thumbs.length;
      }

      if(event.key==='Home'){
        nextIndex=0;
      }

      if(event.key==='End'){
        nextIndex=thumbs.length-1;
      }

      if(nextIndex===null)return;

      event.preventDefault();
      show(nextIndex);
      thumbs[nextIndex].focus();
    });
  });
})();
